





































import { Component, Prop, Vue } from 'vue-property-decorator';
import { EventBlockDto } from '@/api';
import CmsLink from '@/views/cms/snippet/CmsLink.vue';
import moment from 'moment';
import { getModule } from 'vuex-module-decorators';
import UserStore from '@/stores/user/user.store';

@Component({
  components: { CmsLink },
})
export default class EventBlock extends Vue {
  private userStore = getModule(UserStore, this.$store);
  @Prop({required: true})
  public readonly model!: EventBlockDto;

  get imageLocation(): string {
    return this.model.imagePath;
  }

  get startsSoon(): boolean {
    return this.teaser !== '';
  }

  get teaser(): string {
    const startDate = moment(this.model.validFrom);
    const endOfThisWeek = moment().endOf('isoWeek');
    const endOfNextWeek = moment().add(7, 'days').endOf('isoWeek');
    if (startDate.endOf('day').isBefore(moment())) {
      return '';
    } else if (startDate.isSame(moment(), 'day')) {
      return 'today';
    } else if (startDate.isBefore(endOfThisWeek)) {
      return 'thisWeek';
    } else if (startDate.isBefore(endOfNextWeek)) {
      return 'nextWeek';
    }
    return '';
  }

  get multiDaysEvent(): boolean {
    return this.endDate > this.startDate;
  }

  get startDate(): Date {
    return new Date(this.model.validFrom);
  }

  get endDate(): Date {
    return new Date(this.model.validTo);
  }

  get currentLanguage(): string {
    return this.userStore.currentLanguage;
  }

  get containerStyle(): any {
    return {
      'background-color': this.model.backgroundColor,
    };
  }

  public getLongWeekDay(date: Date): string {
    return date.toLocaleDateString(this.currentLanguage, { weekday: 'long' });
  }

  public getLongMonth(date: Date): string {
    return date.toLocaleDateString(this.currentLanguage, { month: 'long' });
  }
}
